<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-1">
              <integration-icon :type="integration.type" class="rounded-circle w-30-p"></integration-icon>
            </div>
            <div class="col-6 col-xl-7">
              <h4 class="m-0 text-truncate">{{ integration.name }}</h4>
            </div>
            <div class="col-4 col-xl-3 d-flex align-items-center">
              <strong>ID:</strong><span class="ml-1 text-muted">{{ integration.id }}</span>
            </div>
          </div>
        </div>
        <div class="position-absolute left-auto right-0">
          <button type="button" class="btn btn-danger mr-2" @click="openDeleteConfirm">
            <icon class="btn-icon" name="trash" :inverse="true"/>
            Delete
          </button>
        </div>
      </div>
    </div>

    <modal-confirm-delete
      :showModal="showDeleteModal"
      @integration-deleted="$router.push({ name: 'administration.integrations'})"
      :integration="integration">
    </modal-confirm-delete>

  </div>
</template>

<script>
  import IntegrationIcon from '@/components/administration/integration/detail/IntegrationIcon'
  import ConfirmDelete from '@/components/administration/integration/common/ConfirmDeleteIntegration'
  import 'vue-awesome/icons/trash'
  import 'vue-awesome/icons/arrow-left'

  export default {
    components: {
      'modal-confirm-delete': ConfirmDelete,
      'integration-icon': IntegrationIcon
    },

    store: {
      integration: 'administration.integrationDetail.integration',
      showDeleteModal: 'administration.integrationDetail.showDeleteModal'
    },

    methods: {
      openDeleteConfirm() {
        this.showDeleteModal = true
      }
    }
  }
</script>
